
import { CountryActions, CountryActionTypes } from '../actions/country.actions';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
  entities: any[];
}

export const initialState: State = {
  isLoaded: false,
  isLoading: false,
  entities: []
};

export function reducer(state = initialState, action: CountryActions): State {
  switch (action.type) {
    case CountryActionTypes.GetCountrys:
      return {...state, isLoading: true, isLoaded: false};
    case CountryActionTypes.LoadCountrys:
      return {...state, isLoading: false, isLoaded: true, entities: action.payload };
    case CountryActionTypes.GetCountrysFail:
      return {...state, isLoading: false, isLoaded: true, entities: []}

    default:
      return state;
  }
}
